import { render, staticRenderFns } from "./ApproveMemberListing.vue?vue&type=template&id=20d5010e"
import script from "./ApproveMemberListing.vue?vue&type=script&lang=js"
export * from "./ApproveMemberListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports